interface FeedItem {
  type: string;
  id: string;
}

interface DynamicTopicResourcePathParams {
  whitelabelURL: string;
  topicId: string | number;
}

interface Topic {
  id: string;
  landing_page?: string;
  pages?: { path: string; enabled: boolean; public: boolean }[];
}

export const getFeedItemTypedId = (feedItem: FeedItem) => {
  if (!feedItem.type) {
    throw new Error('No `type` attribute defined on this item');
  }
  if (!feedItem.id) {
    throw new Error('No `id` attribute defined on this item');
  }

  return `${feedItem.id}-${feedItem.type}`;
};

export const dynamicTopicResourcePath = (
  path: string,
  { whitelabelURL, topicId }: DynamicTopicResourcePathParams,
  pathReplacement: (pathRoute: string) => string = () => '',
) => {
  if (whitelabelURL) {
    const pathRoute = Routes.topic_path(topicId);

    path = path.replace(pathRoute, pathReplacement(pathRoute));
  }

  return path;
};

const formatPath = (path: string) => {
  if (path === '') {
    path = '/';
  }
  if (path !== '/' && path[path.length - 1] === '/') {
    path = path.slice(0, -1);
  }

  return path;
};

// Only in whitelabelURL, if landing is not home, redirect to landing
export const redirectFromPublicRoot = (
  path: string,
  whitelabelURL: string,
  topic: Topic,
) => {
  const topicId = topic.id;
  const homePath = whitelabelURL ? '/' : Routes.topic_path(topicId);
  let landing = topic.landing_page || '';

  landing = dynamicTopicResourcePath(landing, { whitelabelURL, topicId });
  landing = formatPath(landing);
  path = formatPath(path);

  return path === homePath && landing !== homePath;
};

export const currentPageDisplayedPublicly = (
  path: string,
  whitelabelURL: string,
  topic: Topic,
) => {
  path = formatPath(path);
  const pages = (topic.pages ?? []).filter((pg) => {
    const pagePath = formatPath(
      dynamicTopicResourcePath(pg.path, {
        whitelabelURL,
        topicId: topic.id,
      }),
    );

    return path === pagePath;
  });
  const page = pages[0];

  return !page || (page?.enabled && page?.public);
};
